import axios from 'axios';

import { DUTY_LINES, DUTY_LINES_NO_REQUEST } from '../endpoints';

export type CreateDutyLineOptions = {
  duty: Record<string, unknown>;
  deleteAbsences?: boolean;
  ignoreAbsenceOverlap?: boolean;
};

export const createDutyLine = ({
  duty,
  deleteAbsences,
  ignoreAbsenceOverlap
}) =>
  axios.post(
    DUTY_LINES,
    { toCreate: [{ value: duty }] },
    {
      params: {
        deleteAbsences,
        ignoreAbsenceOverlap
      },
      pathParams: {
        employeeId: duty.employeeId
      }
    }
  );

export const createDutyLineWithoutRequest = ({
  duty,
  deleteAbsences,
  ignoreAbsenceOverlap
}) =>
  axios.post(DUTY_LINES_NO_REQUEST, duty, {
    params: {
      deleteAbsences,
      ignoreAbsenceOverlap
    }
  });
